import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-form p-component'
};
var FormStyle = BaseStyle.extend({
  name: 'form',
  classes: classes
});

export { FormStyle as default };
//# sourceMappingURL=index.mjs.map
